import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';

const LOGO_SYMBOL = 'https://customer-assets.emergentagent.com/job_3118c9a4-a94d-4f60-9004-669a5548876d/artifacts/9jvjmy2x_GWINS_Symbol_Metallic_2000px.png';

const HeroSection = () => {
  const scrollToShop = () => {
    document.getElementById('shop')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a0b0c] via-[#131416] to-[#0a0b0c]">
        {/* Metallic texture overlay */}
        <div className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `radial-gradient(circle at 30% 20%, rgba(192, 196, 204, 0.1) 0%, transparent 50%),
                             radial-gradient(circle at 70% 80%, rgba(0, 212, 170, 0.08) 0%, transparent 50%)`
          }}
        />
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
                             linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
            backgroundSize: '50px 50px'
          }}
        />
      </div>

      {/* Centered Logo at Top - Right under cintillo */}
      <div className="relative z-10 flex justify-center pt-6">
        <div className="relative">
          {/* Teal glow effect */}
          <div className="absolute inset-0 blur-3xl bg-[#00d4aa]/20 rounded-full scale-75" />
          <img
            src={LOGO_SYMBOL}
            alt="GWINS Emblem"
            className="relative w-80 sm:w-96 lg:w-[450px] h-auto drop-shadow-2xl"
            style={{
              filter: 'drop-shadow(0 0 30px rgba(0, 212, 170, 0.3))'
            }}
          />
        </div>
      </div>

      {/* Content Section */}
      <div className="relative z-10 flex-1 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
            {/* Content */}
            <div className="flex-1 text-center lg:text-left">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-tight mb-6">
                <span className="text-white">Play Like </span>
                <span className="text-[#00d4aa]">A Pro.</span>
                <br />
                <span className="text-white/80">Pay Like </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c0c4cc] to-[#8a8f98]">A Beginner.</span>
              </h1>
              
              <p className="text-lg sm:text-xl text-white/60 max-w-xl mb-10 leading-relaxed">
                Pro-quality paintball gear for every level—built by players, for players.
                Dominate the field.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <Button 
                  onClick={scrollToShop}
                  className="bg-[#00d4aa] hover:bg-[#33e0bb] text-[#0a0b0c] font-bold rounded-full px-8 py-6 text-base uppercase tracking-wider group"
                >
                  Shop Jerseys
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                {/* Custom Team Orders - Hidden until ready
                <Button 
                  variant="outline"
                  className="border-[#00d4aa] text-[#00d4aa] hover:bg-[#00d4aa] hover:text-[#0a0b0c] rounded-full px-8 py-6 text-base uppercase tracking-wider"
                >
                  Custom Team Orders
                </Button>
                */}
              </div>
            </div>

            {/* Right side - decorative element */}
            <div className="flex-1 hidden lg:flex justify-center lg:justify-end">
              <div className="relative w-80 h-80">
                {/* Decorative circles */}
                <div className="absolute inset-0 border-2 border-[#00d4aa]/10 rounded-full animate-pulse" />
                <div className="absolute inset-8 border border-[#00d4aa]/20 rounded-full" />
                <div className="absolute inset-16 border border-[#00d4aa]/10 rounded-full" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-4 h-4 bg-[#00d4aa] rounded-full shadow-lg shadow-[#00d4aa]/50" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 z-10">
        <span className="text-xs uppercase tracking-wider">Scroll</span>
        <ChevronDown className="h-5 w-5 animate-bounce" />
      </div>
    </section>
  );
};

export default HeroSection;
